import React from 'react'
import { Breadcrumbs, Link } from './styles'
import BreadcrumbConnector, { ConnectorProps as BreadcrumbProps } from '../connectors/Breadcrumb'
import { capitalizeString } from 'lib/helpers'

export default BreadcrumbConnector((props: BreadcrumbProps) => {
  const { name, ownerId } = props
  const capitalizedName = capitalizeString(name)

  return (
    <Breadcrumbs className='link-group-container'>
      <ul data-type='breadcrumbUL'>
        <li>
          <Link href='/all' title='See all artworks'>
            All Artworks
          </Link>
        </li>
        <li>
          <Link title='Collections' href='/collections'>
            Collections
          </Link>
        </li>
        <li>
          <Link title={`${capitalizedName} Collections`} href={`/account/collection/${ownerId}`}>
            {capitalizedName} Collections
          </Link>
        </li>
      </ul>
    </Breadcrumbs>
  )
})
